import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Button, Flex } from "@chakra-ui/react";
import { useFormikContext } from "formik";

interface Props {
  showButton?: boolean;
  isLast?: boolean;
}

export const NextButton: FC<Props> = ({ showButton = true, isLast }) => {
  const { t } = useTranslation();
  const { isSubmitting, isValid } = useFormikContext();

  if (!showButton) return null;

  const ctaCopy = isLast
    ? t("onboarding.ctas.finish")
    : t("onboarding.ctas.next");

  return (
    <Flex justify="flex-end" w="full">
      <Button
        isDisabled={!isValid || isSubmitting}
        size="th-md"
        type="submit"
        variant="th-primary"
        w="146px"
      >
        {ctaCopy}
      </Button>
    </Flex>
  );
};
